import React from 'react';
import QuickActionTemplateManager from '../../components/admin/QuickActionTemplateManager.jsx';

/**
 * QuickActionTemplateManagement page for the new admin structure
 * Wraps the existing QuickActionTemplateManager component
 */
const QuickActionTemplateManagement = () => {
  return <QuickActionTemplateManager />;
};

export default QuickActionTemplateManagement;
